module.exports = __webpack_public_path__ + "fonts/shipnity.e053d133.ttf";